import React from "react";
import Availability from "assets/svg/24-7-availability";
import GuaranteeIcon from "assets/svg/GuaranteeIcon";
import BusinessCustomersIcon from "assets/svg/95000-business-customers";
import ContractIcon from "assets/svg/contract";
import TranslateIcon from "assets/svg/translate";
import LegalIcon from "assets/svg/legal";
import NativeIcon from "assets/svg/native";
import SecurityIcon from "assets/svg/security";
import AtaIcon from "assets/svg/ata";
import BusinessIcon from "assets/svg/business";
import CertifyIcon from "assets/svg/certify";
import EducationIcon from "assets/svg/education";
import FastDeliveryIcon from "assets/svg/fast-delivery";
import GovernmentNewIcon from "assets/svg/government-new";
import MedicalIcon from "assets/svg/medical";
import UscisIcon from "assets/svg/uscis";
import SampleSvg from "assets/svg/sample-svg";

export default function (icon) {
  if (icon === "availability") {
    return <Availability />;
  } else if (icon === "guarantee") {
    return <GuaranteeIcon />;
  } else if (icon === "business-customers") {
    return <BusinessCustomersIcon />;
  } else if (icon === "contract") {
    return <ContractIcon />;
  } else if (icon === "translate") {
    return <TranslateIcon />;
  } else if (icon === "legal") {
    return <LegalIcon />;
  } else if (icon === "native") {
    return <NativeIcon />;
  } else if (icon === "security") {
    return <SecurityIcon />;
  } else if (icon === "ata") {
    return <AtaIcon />;
  } else if (icon === "business") {
    return <BusinessIcon />;
  } else if (icon === "certify") {
    return <CertifyIcon />;
  } else if (icon === "education") {
    return <EducationIcon />;
  } else if (icon === "fast-delivery") {
    return <FastDeliveryIcon />;
  } else if (icon === "government-new") {
    return <GovernmentNewIcon />;
  } else if (icon === "medical") {
    return <MedicalIcon />;
  } else if (icon === "uscis") {
    return <UscisIcon />;
  } else if (icon === "icon_1") {
    return <SampleSvg />;
  }
  return false;
}
